import React from 'react';
import './Logo.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'light' | 'dark';
}

export const Logo: React.FC<LogoProps> = ({ size = 'medium', variant = 'light' }) => {
  return (
    <div className={`logo-component logo-${size} logo-${variant}`}>
      <img 
        src="/Yebo_Market_Full_Logo.png"
        alt="Yebo Fresh" 
        className="logo-image"
      />
    </div>
  );
};